import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { CircularProgress, TextField } from '@material-ui/core';

export const ChangePhoneNumberModal = ({ open, handleClose, loading }) => {
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [error, setError] = useState(false);

  const handleFormatPhoneNumber = () => {
    if (phoneNumber.length !== 11 || phoneNumber.slice(0, 2) !== '09') {
      return setError(true);
    }
    return handleClose(true, phoneNumber);
  };

  const handleChangePhone = (phoneNumber) => {
    setError(false);
    setPhoneNumber(phoneNumber);
  };
  return (
    <Dialog
      open={open}
      onClose={() => handleClose(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">تغییر شماره موبایل</DialogTitle>
      <DialogContent>
        <TextField
          placeholder="۰۹۱۲۳۴۵۶۷۸۹"
          className="my-3"
          size="small"
          fullWidth
          variant="outlined"
          onChange={(e) => handleChangePhone(e.target.value)}
          error={error}
          helperText={error && 'لطفا شماره موبایل را به صورت صحیح وارد کنید.'}
          inputProps={{
            pattern: '[0-9]*',
            inputMode: 'numeric',
            maxLength: 11,
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          disabled={loading}
          onClick={() => handleClose(false)}
          color="primary"
        >
          صرف نظر
        </Button>
        <Button
          onClick={handleFormatPhoneNumber}
          color="secondary"
          variant="contained"
          autoFocus
          disabled={loading}
          endIcon={loading && <CircularProgress size={10} />}
        >
          تایید
        </Button>
      </DialogActions>
    </Dialog>
  );
};
